var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByTrophicLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.3333L15 1.66667C15 0.747502 14.2525 1.24599e-06 13.3333 1.16564e-06L1.66667 1.45705e-07C0.747502 6.53486e-08 1.24599e-06 0.7475 1.16564e-06 1.66667L1.45705e-07 13.3333C6.53485e-08 14.2525 0.7475 15 1.66667 15L13.3333 15C14.2525 15 15 14.2525 15 13.3333ZM1.66584 1.66667L13.3333 1.66667L13.3333 13.3333L1.66667 13.3333L1.66584 1.66667Z",
    fill: "#303752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 11.6667L6.66699 11.6667L6.66699 3.33335L8.33366 3.33336L8.33366 11.6667ZM5.00033 9.16669L3.33366 9.16669L3.33366 3.33335L5.00033 3.33335L5.00033 9.16669ZM11.667 7.50002L10.0003 7.50002L10.0003 3.33336L11.667 3.33336L11.667 7.50002Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByTrophicLevel);
export default __webpack_public_path__ + "static/media/by-trophic-level.932565a2b9e515f058c17afd9d4a804e.svg";
export { ForwardRef as ReactComponent };